import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 41,
        },
        flexContainer: ({ theme: { unstable_sx: sx } }) =>
          sx({
            gap: 2,
          }),
      },
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            px: 0.75,
            py: 0.5,
            minHeight: 32,
            color: theme.palette.grey[600],
            borderRadius: 1.75,
            '&.Mui-selected': {
              color: theme.palette.grey[800],
            },
            ':hover': {
              bgcolor: theme.palette.grey[100],
            },
          }),
      },
    },
  },
});

export default theme.components;
